import React from "react";

export function OtpInput({ value, onChange, disabled, testid = "otp-input" }) {
  const refs = React.useRef([]);
  const digits = value.padEnd(6, " ").slice(0, 6).split("");

  const setDigit = (i, d) => {
    const clean = d.replace(/\D/g, "").slice(-1);
    const next = digits.map((c, idx) => (idx === i ? (clean || " ") : c)).join("").replace(/ /g, "");
    onChange(next);
    if (clean && i < 5) refs.current[i + 1]?.focus();
  };

  const onKey = (i, e) => {
    if (e.key === "Backspace" && !digits[i].trim() && i > 0) refs.current[i - 1]?.focus();
  };

  const onPaste = (e) => {
    e.preventDefault();
    const text = e.clipboardData.getData("text").replace(/\D/g, "").slice(0, 6);
    if (text) { onChange(text); refs.current[Math.min(text.length, 5)]?.focus(); }
  };

  return (
    <div className="flex gap-2 justify-center" data-testid={testid}>
      {digits.map((d, i) => (
        <input
          key={i}
          ref={(el) => (refs.current[i] = el)}
          value={d.trim()}
          onChange={(e) => setDigit(i, e.target.value)}
          onKeyDown={(e) => onKey(i, e)}
          onPaste={onPaste}
          disabled={disabled}
          inputMode="numeric"
          maxLength={1}
          autoFocus={i === 0}
          data-testid={`${testid}-digit-${i}`}
          className="h-12 w-11 rounded-lg border border-slate-300 bg-white text-center text-xl font-bold text-vs-ink focus:border-vs-royal focus:ring-2 focus:ring-vs-royal/20 outline-none transition-colors disabled:opacity-50"
        />
      ))}
    </div>
  );
}

export function maskEmail(email = "") {
  const [name, domain] = email.split("@");
  if (!domain) return email;
  const shown = name.length <= 1 ? name : `${name[0]}${"*".repeat(Math.min(name.length - 1, 4))}`;
  return `${shown}@${domain}`;
}
